const nonNull = <T extends any>(x: T): x is NonNullable<T> => x != null;

export default nonNull;